import type { VoiceCue } from './audio';

export const VOICE_CUES: VoiceCue[] = ['intro', 'win', 'lose', 'undo'];

export const VOICE_CUE_LABEL: Record<VoiceCue, string> = {
  intro: '登場',
  win: '玩家獲勝',
  lose: '守局人獲勝',
  undo: '悔棋',
};

export const VOICE_LINES: Record<string, Record<VoiceCue, string>> = {
  apprentice: {
    intro: '我是沐光學徒。先看清楚棋盤，再決定怎麼下。讓我看看你的布局。',
    win: '原來那一手早已埋好。這局是你贏了，我記住了。',
    lose: '我找到空隙了。別灰心，再下一局，我們都會更強。',
    undo: '呵呵，好哦。',
  },
  keeper: {
    intro: '我是青竹棋士，請多指教。你的攻勢，我會一手一手接住。',
    win: '守得太緊，反而失了先機。好棋，這局我認輸。',
    lose: '竹影不動，破綻自現。這一局，由我守下。',
    undo: '呵，原來你也會後悔。',
  },
  strategist: {
    intro: '我是赤紋策士。從第一手開始，我就要奪走主動。',
    win: '你竟從攻勢裡找到反擊。漂亮，這局算你更快一步。',
    lose: '一處活三，只是開端。當你看見五子時，勝負早已決定。',
    undo: '呵呵，現在才看見陷阱？',
  },
  weaver: {
    intro: '玄霧棋師，靜候多時。你以為我在防守，也許下一手，便是進攻。',
    win: '霧散之後，仍是你看得更遠。這一局，我無話可說。',
    lose: '黑白易位，攻守無常。當你追上影子時，真正的棋，早已在別處。',
    undo: '呵，連你自己，也分不清哪一手才是真的？',
  },
  guardian: {
    intro: '雲門之前，沒有僥倖。落子吧，讓我看看你的全局。',
    win: '能破此局，你已不再只是來訪者。雲門，為你而開。',
    lose: '你輸的不是最後一手，而是更早以前的一次遲疑。再來吧。',
    undo: '呵呵，棋能退，遲疑可退不了。',
  },
};
